import React from 'react';
import propTypes from './propTypes';

const AboutAlertsTelematics = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 14H5.68499L6.83969 12H3V10.6348L4.85984 8H9.14909L10.3038 6H4.34169C4.01676 6 3.7121 6.15787 3.52472 6.42332L3 7.16667V5C3 4.44772 3.44772 4 4 4H11.4585L12.6132 2H4C2.34315 2 1 3.34315 1 5V22C1 22.5523 1.44772 23 2 23H4C4.55228 23 5 22.5523 5 22V21H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V16.2225H15V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V14Z" fill="currentColor" />
    <path d="M6.97441 16.2227H4.02559C4.00879 16.3125 4 16.4053 4 16.5C4 17.3284 4.67157 18 5.5 18C6.32843 18 7 17.3284 7 16.5C7 16.4053 6.99121 16.3125 6.97441 16.2227Z" fill="currentColor" />
    <path d="M12.5553 14H7.41704L8.57174 12H10.8384L10.3999 12.7595H12.5553V14Z" fill="currentColor" />
    <path d="M15 14V14.7225H16.4813V12.7595H14.5183V14H15Z" fill="currentColor" />
    <path d="M15 11.778V10.9522C15 10.7456 14.9361 10.5442 14.817 10.3755L14.5183 9.95242V7.85199H16.4813V11.778H15Z" fill="currentColor" />
    <path d="M13.1402 8L13.1444 8.00596L14.2076 6.16437C14.0467 6.05858 13.8562 6 13.6583 6H12.0358L10.8811 8H13.1402Z" fill="currentColor" />
    <path d="M14.9838 4.81992L15.4999 3.92601L17 6.5242V5C17 3.45625 15.834 2.18484 14.3346 2.01845L13.1905 4H14C14.4908 4 14.899 4.35359 14.9838 4.81992Z" fill="currentColor" />
    <path d="M13.9744 16.2225H11.0256C11.0088 16.3124 11 16.4052 11 16.5C11 17.3284 11.6716 18 12.5 18C13.3284 18 14 17.3284 14 16.5C14 16.4052 13.9912 16.3124 13.9744 16.2225Z" fill="currentColor" />
    <path d="M15.5 0L7 14.7224H12.5554V12.7594H10.4L15.5 3.92598L20.6 12.7594H18.4444V14.7224H24L15.5 0Z" fill="currentColor" />
    <path d="M14.5184 7.85196H16.4814V11.7779H14.5184V7.85196Z" fill="currentColor" />
    <path d="M14.5184 12.7594H16.4814V14.7224H14.5184V12.7594Z" fill="currentColor" />
  </svg>
);

AboutAlertsTelematics.propTypes = propTypes;

export default AboutAlertsTelematics;
